import { styled } from '@mui/material/styles';

export const StyledContent = styled('div', {
    shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
    '& h1': {
        ...theme.typography.h1,
        marginBottom: theme.spacing(2),
    },
    '& h2': {
        ...theme.typography.h2,
        marginBottom: theme.spacing(2),
    },
    '& p': {
        ...theme.typography.body1,
        marginTop: compact ? 0 : undefined,
        marginBottom: compact ? 0 : theme.spacing(2),
    },
    '& ul, & ol': {
        marginBottom: theme.spacing(2),
        paddingInlineStart: theme.spacing(3),
    },
    '& li': {
        ...theme.typography.body1,
        marginBottom: theme.spacing(1),
    },
    '& a': {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}));
